import { client } from "service/service";

export const getAttributesByType = async (type: string) => {
  try {
    const res = await client.get(`attributes/type/${type}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}